import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faQuoteLeft,
  faExternalLinkAlt,
  faChevronDown,
  faChevronUp,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const SingleReviewCard = ({ review, index }) => {
  const { title, content, author, source, source_url } = review;
  const { i18n } = useTranslation();
  const isEnglish = (i18n.language || "it").startsWith("en");
  const [isExpanded, setIsExpanded] = useState(false);

  const isLong = content && content.length > 360;
  const displayContent = isLong && !isExpanded ? content.slice(0, 360) + "..." : content;

  // Star rating detection
  const hasFourStars =
    title?.includes("4/5") ||
    title?.includes("****") ||
    content?.includes("4/5 stelle") ||
    content?.includes("Valutazione: ****");

  return (
    <div className="card review-press-card border-0 shadow-sm rounded-4 mb-4 p-4 p-md-5 bg-white">
      {/* Card Header: Rating or Source Badge */}
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div className="review-quote-icon-box">
          <FontAwesomeIcon icon={faQuoteLeft} className="text-warning fs-3" />
        </div>
        {hasFourStars && (
          <div className="review-star-rating">
            {[...Array(5)].map((_, i) => (
              <FontAwesomeIcon
                key={i}
                icon={faStar}
                className={i < 4 ? "text-warning" : "text-muted opacity-25"}
              />
            ))}
          </div>
        )}
      </div>

      {/* Review Title */}
      {title && title !== "Title Not Found" && (
        <h4 className="review-card-title mb-3">{title}</h4>
      )}

      {/* Review Content */}
      <div className="review-card-content text-start mb-3">
        <p className="lead-quote-text mb-2">{displayContent}</p>
        {isLong && (
          <button
            type="button"
            className="btn btn-link btn-sm p-0 text-decoration-none fw-semibold text-warning"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? (
              <>
                {isEnglish ? "Show less" : "Mostra meno"}{" "}
                <FontAwesomeIcon icon={faChevronUp} className="ms-1" />
              </>
            ) : (
              <>
                {isEnglish ? "Read full review" : "Leggi tutta la recensione"}{" "}
                <FontAwesomeIcon icon={faChevronDown} className="ms-1" />
              </>
            )}
          </button>
        )}
      </div>

      {/* Review Footer / Source Attribution */}
      <div className="review-card-footer pt-3 border-top d-flex flex-wrap align-items-center justify-content-between gap-2 mt-auto">
        <div className="review-author-info">
          {author && <span className="fw-bold text-dark me-2">{author}</span>}
          {source && <span className="text-muted small">({source})</span>}
        </div>

        {source_url && source_url !== "URL Not Found" && (
          <a
            href={source_url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-outline-secondary rounded-pill px-3 review-source-link"
          >
            {isEnglish ? "Read Original" : "Fonte Originale"}{" "}
            <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1 small" />
          </a>
        )}
      </div>
    </div>
  );
};

const RevCard = ({ reviews }) => {
  return (
    <div className="reviews-list">
      {reviews.map((review, index) => (
        <SingleReviewCard key={index} review={review} index={index} />
      ))}
    </div>
  );
};

export default RevCard;
